export default __webpack_public_path__ + "static/media/icon_location_power_outage_true.f567aeea.svg";